export default "__VITE_ASSET__BG4Os7Hb__"